module.exports = __webpack_public_path__ + "static/InTow-Connect-Mobile-User-Guide-67e32cef4578aa6829f227b982efe632.pdf";